import { baseForPdf } from '../apiClients';
import { Endpoints } from '../../network';
import { IResponse } from '../../utils/interfaces';

export interface IRoutePopupImage {
  webKey: string;
  tabKey: string;
  phoneKey: string;
  appKey: string;
  expireIn: number;
  link: string;
}

export interface IRoutePopup {
  _id: string;
  route: string[];
  images: IRoutePopupImage[];
  isActive: boolean;
  expireIn: number;
  createdAt: string;
  updatedAt: string;
}

export const getRoutePopup = async (
  route: string,
): Promise<IResponse<IRoutePopup | null>> => {
  const response = await baseForPdf.get(Endpoints.getRoutePopup, {
    params: { route },
  });
  return response?.data;
};
